//Components
import IncidentPanels from "./IncidentPanels";

const IncidentPanelsWrapper = ({
  setPopper,
  chatWindowRef,
  openChat,
  subscriptionServer,
  incident,
  target,
  incidentIndex,
  handlePersonOpening,
  handleIncidentOpening,
  handleTicketOpening,
  handleVehicleOpening,
  getCallInfo,
  getCallInfoExpandFrame,
  setPausePolling,
  userPreferences,
  setUserPreferences,
  socketConnected = false,
}) => {
  return (
    <IncidentPanels
      setPopper={setPopper}
      chatWindowRef={chatWindowRef}
      openChat={openChat}
      subscriptionServer={subscriptionServer}
      incident={incident}
      target={target}
      incidentIndex={incidentIndex}
      handlePersonOpening={handlePersonOpening}
      handleIncidentOpening={handleIncidentOpening}
      handleTicketOpening={handleTicketOpening}
      handleVehicleOpening={handleVehicleOpening}
      getCallInfo={getCallInfo}
      setPausePolling={setPausePolling}
      userPreferences={userPreferences}
      setUserPreferences={setUserPreferences}
      socketConnected={socketConnected}
      getCallInfoExpandFrame={getCallInfoExpandFrame}
    />
  );
};

export default IncidentPanelsWrapper;
